// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1BYmA","empty":"ModalGraph_empty__3FQy4"};